import type { LanguageStrings } from "../types";
import { englishLocalizedStrings } from "../english";

export const englishUSLocalizedStrings: LanguageStrings = {
    ...englishLocalizedStrings,
    favorites: "Favorites",
    favorite: "Favorite",
    zip: "Zip",
    uploadNImages: "Upload {0} Images",
    dragImagesHereOr: "Drag images here or",
    addNImages: "Add {0} images",
    chartsNoLabelValue: "(no value)",
    lastNHours: "Last {0} hours",
    lastNDays: "Last {0} days",
    lastNMonths: "Last {0} months",
    lastWeek: "Last week",
    lastMonth: "Last month",
    lastQuarter: "Last quarter",
    lastYear: "Last year",
    dayToNow: "Day to now",
    weekToDate: "Week to date",
    monthToDate: "Month to date",
    quarterToDate: "Quarter to date",
    yearToDate: "Year to date",
    custom: "Custom",
    hour: "Hour",
    year: "Year",
    quarter: "Quarter",
};
